/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Autocomplete1Params,
  BaseResponseAutocompleteResponse,
  BaseResponseNoticeResponse,
  BaseResponsePageResponseNoticeDto,
  BaseResponsePolicyResponse,
  BaseResponseString,
  CreateNoticeRequest,
  GetNoticePageParams,
  GetPolicyParams,
  UpdateNoticeRequest,
} from './data-contracts';
import {ContentType, HttpClient, RequestParams} from './http-client';

export class Notice<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 공지사항을 수정합니다.
   *
   * @tags Notice
   * @name UpdateNotice
   * @summary 공지사항 수정
   * @request PUT:/app/notices/{uuid}
   * @secure
   * @response `201` `BaseResponseNoticeResponse` Created
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateNotice = async (uuid: string, data: UpdateNoticeRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseNoticeResponse, void>({
      path: `/app/notices/${uuid}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 공지사항을 삭제합니다.
   *
   * @tags Notice
   * @name DeleteNotice
   * @summary 공지사항 삭제
   * @request DELETE:/app/notices/{uuid}
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  deleteNotice = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/notices/${uuid}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 신규 공지사항을 등록합니다.
   *
   * @tags Notice
   * @name PostCreateNotice
   * @summary 공지사항 등록
   * @request POST:/app/notices
   * @secure
   * @response `201` `BaseResponseNoticeResponse` Created
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  postCreateNotice = async (data: CreateNoticeRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseNoticeResponse, void>({
      path: `/app/notices`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description ID로 특정 공지사항의 상세내용을 조회합니다.
   *
   * @tags Notice
   * @name GetNoticeById
   * @summary ID로 공지사항 상세내용 조회
   * @request GET:/app/notices/{noticeUuid}
   * @secure
   * @response `200` `BaseResponseNoticeResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getNoticeByIdKey = (noticeUuid: string) => ['app', 'notices', noticeUuid];

  getNoticeById = async (noticeUuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseNoticeResponse, void>({
      path: `/app/notices/${noticeUuid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 공지사항을 페이지 형태로 조회합니다. (조건이 들어오면 조건 검색)
   *
   * @tags Notice
   * @name GetNoticePage
   * @summary 공지사항 페이지 조회
   * @request GET:/app/notices/search
   * @secure
   * @response `200` `BaseResponsePageResponseNoticeDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getNoticePageKey = (query: GetNoticePageParams) => ['app', 'notices', 'search', query];

  getNoticePage = async (query: GetNoticePageParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseNoticeDto, void>({
      path: `/app/notices/search`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 정책을 조회합니다.
   *
   * @tags Notice
   * @name GetPolicy
   * @summary 최신 정책 조회
   * @request GET:/app/notices/policy
   * @response `200` `BaseResponsePolicyResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getPolicyKey = (query: GetPolicyParams) => ['app', 'notices', 'policy', query];

  getPolicy = async (query: GetPolicyParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePolicyResponse, void>({
      path: `/app/notices/policy`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 1음절 이상 입력 시 관련 공지 제목 및 작성자를 검색합니다.
   *
   * @tags Notice
   * @name Autocomplete1
   * @summary 공지사항 제목 및 작성자 자동완성
   * @request GET:/app/notices/autocomplete
   * @secure
   * @response `200` `BaseResponseAutocompleteResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  autocomplete1Key = (query: Autocomplete1Params) => ['app', 'notices', 'autocomplete', query];

  autocomplete1 = async (query: Autocomplete1Params, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseAutocompleteResponse, void>({
      path: `/app/notices/autocomplete`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
